<template>
  <div
    class="attachments-container"
    data-testid="attachment"
    @click.stop.prevent="handleClick"
  >
    <div class="attachment relative">
      <img
        v-show="!hideAttachment"
        :alt="$t('social_mention_card_attached_media_asset.attachment')"
        class="absolute-center full-width"
        data-testid="attachment-image"
        loading="lazy"
        :src="thumbnail"
        @error="hideAttachment = true"
      />

      <template v-if="assetIsPlayable">
        <BaseIcon
          v-if="hideAttachment"
          class="absolute-center tw:text-white"
          icon="video-placeholder"
          size="24px"
        />

        <QIcon
          v-else
          class="play-icon absolute-center"
          name="img:https://assets.streem.com.au/icons/play_CTA_overlay.svg"
          size="14px"
        />

        <span
          v-if="type === 'animated_gif'"
          class="indicator left"
        >
          {{ $t("social_mention_card_attached_media_asset.gif") }}
        </span>

        <span
          v-if="duration"
          class="indicator right"
        >
          {{ secondsToTimecodeWithSeconds(duration) }}
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import { BaseIcon } from "shared/components/base";
import { secondsToTimecodeWithSeconds } from "shared/helpers/date";
import { openLink } from "shared/helpers/external";
import { isWebVideoFileUrl } from "shared/helpers/media";

export default {
  name: "SocialMentionCardAttachedMediaAsset",
  components: { BaseIcon },
  props: {
    type: {
      type: String,
      default: "photo",
      validator(value) {
        return ["photo", "video", "animated_gif"].includes(value);
      },
    },
    thumbnail: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: "",
    },
    duration: {
      type: Number,
      default: 0,
    },
    playMediaInLightbox: {
      type: Boolean,
    },
  },
  emits: ["click"],
  data() {
    return {
      hideAttachment: false,
    };
  },
  computed: {
    assetIsPlayable() {
      return ["video", "animated_gif"].includes(this.type);
    },
    isVideo() {
      return isWebVideoFileUrl(this.url);
    },
  },
  methods: {
    secondsToTimecodeWithSeconds,
    handleClick() {
      if (this.url && !this.playMediaInLightbox) {
        openLink(this.url);
      } else if (this.assetIsPlayable && !this.isVideo) {
        openLink(this.url);
      } else {
        this.$emit("click");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment {
  width: 68px;
  height: 42px;
  background: $ds-denim-3;
  border-radius: 4px;
  overflow: hidden;
}

.play-icon {
  z-index: 1;
}

.indicator {
  display: block;
  background: rgba($black, 0.75);
  border-radius: 2px;
  font-size: 10px;
  font-weight: 700;
  color: $white;
  position: absolute;
  bottom: 0;
  margin: 2px;
  padding: 0 2px;
  user-select: none;

  &.left {
    left: 0;
  }

  &.right {
    right: 0;
  }
}
</style>
